// src/services/userDepositAccountService.js
import { toast } from 'react-toastify';
import AuthService from './authService';

class UserDepositAccountService {
  static get apiBase() {
    return window.APP_CONFIG?.apiUrl || 'https://api.dpg.net.tr';
    //return process.env.REACT_APP_API_URL || 'https://localhost:44330';
  }

  static parseError = async (response) => {
    const fallback = { message: `Request failed with status ${response.status}` };
    const contentType = response.headers.get('content-type') || '';

    if (!contentType.includes('application/json')) {
      return fallback;
    }

    try {
      return await response.json();
    } catch {
      return fallback;
    }
  };

  // Get deposit accounts by customer ID
  static getDepositAccountsByCustomerId = async (customerId) => {
    try {
      const response = await fetch(`${this.apiBase}/api/userDepositAccount/getByCustomerId?customerId=${customerId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${AuthService.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        return {
          success: true,
          data: data
        };
      } else if (response.status === 404) {
        return {
          success: false,
          message: 'No deposit account found for this user',
          data: []
        };
      } else {
        const error = await this.parseError(response);
        return {
          success: false,
          message: error.message || 'Deposit accounts could not be retrieved',
          data: []
        };
      }
    } catch (error) {
      console.error('Error fetching deposit accounts:', error);
      return {
        success: false,
        message: 'Server error occurred',
        data: []
      };
    }
  };

  // Create default deposit account for a user (Admin only)
  static createDefaultDepositAccount = async (userId) => {
    try {
      const response = await fetch(`${this.apiBase}/api/userDepositAccount/createDefault?userId=${userId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${AuthService.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const result = await response.json();
        toast.success(result.message);
        return {
          success: true,
          data: result.data,
          message: result.message
        };
      } else {
        const error = await this.parseError(response);
        toast.error(error.message || 'Deposit account could not be created');
        return {
          success: false,
          message: error.message || 'Deposit account could not be created'
        };
      }
    } catch (error) {
      console.error('Error creating deposit account:', error);
      toast.error('Server error occurred');
      return {
        success: false,
        message: 'Server error occurred'
      };
    }
  };

  // Create a new deposit account for a customer
  static createDepositAccount = async (userId) => {
    try {
      const response = await fetch(`${this.apiBase}/api/userDepositAccount/create`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${AuthService.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId })
      });

      if (response.ok) {
        const result = await response.json();
        toast.success(result.message);
        return {
          success: true,
          data: result.data,
          message: result.message
        };
      } else {
        const error = await this.parseError(response);
        toast.error(error.message || 'Deposit account could not be created');
        return {
          success: false,
          message: error.message || 'Deposit account could not be created'
        };
      }
    } catch (error) {
      console.error('Error creating deposit account:', error);
      toast.error('Server error occurred');
      return {
        success: false,
        message: 'Server error occurred'
      };
    }
  };
}

export default UserDepositAccountService;
